// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Woao","clinicsSelect":"TableHeading_clinicsSelect__2WYIg"};